/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_Ask_PlaceholderInputs */

const es_home_nexy_ask_placeholder = /** @type {(inputs: Home_Nexy_Ask_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntale algo a Nexy...`)
};

const en_home_nexy_ask_placeholder = /** @type {(inputs: Home_Nexy_Ask_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask Nexy something...`)
};

/**
* | output |
* | --- |
* | "Ask Nexy something..." |
*
* @param {Home_Nexy_Ask_PlaceholderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_ask_placeholder = /** @type {((inputs?: Home_Nexy_Ask_PlaceholderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_Ask_PlaceholderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_ask_placeholder(inputs)
	return en_home_nexy_ask_placeholder(inputs)
});
export { home_nexy_ask_placeholder as "home.nexy.ask_placeholder" }